/* Dlook header behaviour: overlays, theme toggle, predictive search, cart drawer.
 *
 * Ported from the design export. Deliberately dependency-free so it does not
 * have to line up with Horizon's web-component lifecycle.
 *
 * Every DOM lookup happens at call time rather than on load. Shopify re-renders
 * a section's markup on each setting change in the theme editor (and on hot
 * reload during development) without re-running this script, so cached element
 * references go stale and the drawers stop opening.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var openPanel = null;
  var lastFocus = null;

  var CLOSED_TRANSFORMS = ['-translate-x-full', 'translate-x-full', '-translate-y-full'];

  function panel(name) {
    return document.querySelector('[data-dlook-panel="' + name + '"]');
  }

  function scrim() {
    return document.querySelector('[data-dlook-scrim]');
  }

  // Panels start off-screen via a transform utility; which one differs per
  // panel, so read it off the element instead of assuming.
  function closedTransformOf(el) {
    return el.dataset.dlookClosed || null;
  }

  function rememberClosedTransform(el) {
    if (el.dataset.dlookClosed) return;
    for (var i = 0; i < CLOSED_TRANSFORMS.length; i++) {
      if (el.classList.contains(CLOSED_TRANSFORMS[i])) {
        el.dataset.dlookClosed = CLOSED_TRANSFORMS[i];
        return;
      }
    }
  }

  /* ---------------------------------------------------------------- panels */

  function open(name) {
    var el = panel(name);
    if (!el || openPanel === name) return;
    if (openPanel) close({ instant: true });

    rememberClosedTransform(el);
    lastFocus = document.activeElement;
    openPanel = name;

    var veil = scrim();
    el.hidden = false;
    if (veil) veil.hidden = false;
    void el.offsetWidth; // flush, so the transition runs from the closed state

    var closed = closedTransformOf(el);
    if (closed) el.classList.remove(closed);
    if (veil) veil.classList.replace('opacity-0', 'opacity-100');

    root.style.overflow = 'hidden';
    setExpanded(name, true);

    var focusable = el.querySelector('input, button, a[href]');
    if (focusable) focusable.focus({ preventScroll: true });

    if (name === 'cart') loadCart();
  }

  function close(opts) {
    if (!openPanel) return;
    var name = openPanel;
    var el = panel(name);
    var veil = scrim();
    openPanel = null;

    root.style.overflow = '';
    setExpanded(name, false);

    if (!el) return;
    var closed = closedTransformOf(el);
    if (closed) el.classList.add(closed);
    if (veil) veil.classList.replace('opacity-100', 'opacity-0');

    var finish = function () {
      if (openPanel) return; // something else opened in the meantime
      el.hidden = true;
      if (veil) veil.hidden = true;
    };

    if (opts && opts.instant) finish();
    else window.setTimeout(finish, 300);

    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function setExpanded(name, isOpen) {
    document.querySelectorAll('[data-dlook-open="' + name + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* -------------------------------------------------------------- listeners */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-dlook-open]');
    if (opener) {
      event.preventDefault();
      open(opener.dataset.dlookOpen);
      return;
    }

    if (target.closest('[data-dlook-close]')) {
      event.preventDefault();
      close();
      return;
    }

    if (target.closest('[data-dlook-scrim]')) {
      close();
      return;
    }

    var tab = target.closest('[data-dlook-tab]');
    if (tab) {
      event.preventDefault();
      selectTab(tab.dataset.dlookTab);
      return;
    }

    var submenu = target.closest('[data-dlook-submenu]');
    if (submenu) {
      event.preventDefault();
      toggleSubmenu(submenu);
      return;
    }
  });

  /* ---------------------------------------------------- drawer tabs */

  function selectTab(name) {
    document.querySelectorAll('[data-dlook-tab]').forEach(function (btn) {
      var isActive = btn.dataset.dlookTab === name;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', String(isActive));
      // Roving tabindex: only the selected tab is in the tab order.
      btn.tabIndex = isActive ? 0 : -1;
    });

    document.querySelectorAll('[data-dlook-tabpanel]').forEach(function (panel) {
      panel.hidden = panel.dataset.dlookTabpanel !== name;
    });

    var body = document.querySelector('.dlook-drawer__body');
    if (body) body.scrollTop = 0;
  }

  function toggleSubmenu(button) {
    var isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isOpen));

    // The menu tab nests two independent toggle levels: .dlook-drawer__sub
    // under a top-level row, .dlook-drawer__subsub under a second-level row.
    var sub = button.nextElementSibling;
    if (sub && (sub.classList.contains('dlook-drawer__sub') || sub.classList.contains('dlook-drawer__subsub'))) {
      sub.hidden = isOpen;
    }
  }

  // Left/right arrows move between tabs, as expected of a tablist.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (!event.target.closest || !event.target.closest('[data-dlook-tab]')) return;

    var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-dlook-tab]'));
    var current = tabs.indexOf(event.target.closest('[data-dlook-tab]'));
    if (current === -1) return;

    var step = event.key === 'ArrowRight' ? 1 : -1;
    var next = tabs[(current + step + tabs.length) % tabs.length];

    event.preventDefault();
    selectTab(next.dataset.dlookTab);
    next.focus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  /* ------------------------------------------------------------- currency */

  function moneyFormat() {
    var el = panel('cart');
    return (el && el.dataset.moneyFormat) || '${{amount}}';
  }

  function withThousands(value, separator) {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');

    return moneyFormat().replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount_no_decimals':
          return withThousands(parts[0], ',');
        case 'amount_with_comma_separator':
          return withThousands(parts[0], '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return withThousands(parts[0], '.');
        default:
          return withThousands(parts[0], ',') + '.' + parts[1];
      }
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* -------------------------------------------------- predictive search */

  var searchTimer = null;
  var searchController = null;

  function renderSearch(products, query) {
    var results = document.querySelector('[data-dlook-search-results]');
    if (!results) return;

    if (!products.length) {
      results.innerHTML =
        '<p class="py-6 text-[13px] text-[var(--muted)]">No products match &ldquo;' +
        escapeHtml(query) +
        '&rdquo;.</p>';
      return;
    }

    results.innerHTML =
      '<div class="dlook-grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">' +
      products
        .map(function (p) {
          var image = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          return (
            '<a class="group block" href="' + p.url + '">' +
            '<div class="relative aspect-[3/4] overflow-hidden bg-[var(--surface)]">' +
            (image
              ? '<img src="' + image + '" alt="' + escapeHtml(p.title) +
                '" loading="lazy" class="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105">'
              : '') +
            '</div>' +
            '<div class="mt-3 flex items-start justify-between gap-3">' +
            '<span class="text-[13px] leading-snug">' + escapeHtml(p.title) + '</span>' +
            '<span class="shrink-0 text-[13px]">' + (p.price ? formatMoney(p.price) : '') + '</span>' +
            '</div></a>'
          );
        })
        .join('') +
      '</div>';
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('[data-dlook-search-input]')) return;

    var results = document.querySelector('[data-dlook-search-results]');
    var query = event.target.value.trim();
    window.clearTimeout(searchTimer);

    if (!results) return;
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }

    searchTimer = window.setTimeout(function () {
      if (searchController) searchController.abort();
      searchController = new AbortController();

      var url =
        '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';

      fetch(url, { signal: searchController.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSearch(products, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          results.innerHTML =
            '<p class="py-6 text-[13px] text-[var(--muted)]">Search is unavailable right now.</p>';
        });
    }, 220);
  });

  /* ----------------------------------------------------------- cart drawer */

  function setCount(count) {
    document.querySelectorAll('[data-dlook-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-dlook-cart-body]');
    var footer = document.querySelector('[data-dlook-cart-footer]');
    var total = document.querySelector('[data-dlook-cart-total]');
    if (!body) return;

    setCount(cart.item_count);

    if (!cart.items.length) {
      body.innerHTML = '<p class="py-10 text-center text-[13px] text-[var(--muted)]">Your cart is empty.</p>';
      if (footer) footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items
      .map(function (item, index) {
        var image = item.image
          ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) +
            '" class="h-full w-full object-cover" loading="lazy">'
          : '';
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="mt-1 text-[12px] text-[var(--muted)]">' + escapeHtml(item.variant_title) + '</p>'
            : '';

        return (
          '<div class="flex gap-4 border-b border-[var(--line-soft)] py-4">' +
          '<a href="' + item.url + '" class="block h-[104px] w-[78px] shrink-0 overflow-hidden bg-[var(--surface)]">' + image + '</a>' +
          '<div class="flex min-w-0 flex-1 flex-col">' +
          '<a href="' + item.url + '" class="text-[13px] leading-snug">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="mt-auto flex items-center justify-between gap-3 pt-3">' +
          '<div class="flex items-center border border-[var(--line)]">' +
          '<button type="button" aria-label="Decrease quantity" data-dlook-qty="' + (index + 1) + '" data-delta="-1" class="flex h-8 w-8 items-center justify-center text-[15px]">&minus;</button>' +
          '<span data-dlook-qty-value class="w-8 text-center text-[13px]">' + item.quantity + '</span>' +
          '<button type="button" aria-label="Increase quantity" data-dlook-qty="' + (index + 1) + '" data-delta="1" class="flex h-8 w-8 items-center justify-center text-[15px]">+</button>' +
          '</div>' +
          '<span class="text-[13px]">' + formatMoney(item.line_price) + '</span>' +
          '</div></div></div>'
        );
      })
      .join('');

    if (total) total.textContent = formatMoney(cart.total_price);
    if (footer) footer.hidden = false;
  }

  function cartUrl() {
    var el = panel('cart');
    return (el && el.dataset.cartUrl) || '/cart';
  }

  function loadCart() {
    var body = document.querySelector('[data-dlook-cart-body]');
    if (!body) return;
    body.innerHTML = '<p class="py-10 text-center text-[13px] text-[var(--muted)]">Loading&hellip;</p>';

    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        body.innerHTML = '<p class="py-10 text-center text-[13px] text-[var(--muted)]">Could not load your cart.</p>';
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-dlook-qty]');
    if (!button) return;

    var line = Number(button.dataset.dlookQty);
    var delta = Number(button.dataset.delta);
    var valueEl = button.parentElement.querySelector('[data-dlook-qty-value]');
    var next = Math.max(0, Number(valueEl.textContent) + delta);

    button.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: next }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(loadCart);
  });

  // Let other sections (quick add, product form) drive the drawer.
  document.addEventListener('dlook:cart:refresh', loadCart);
  // The header count went stale everywhere else the cart changes: Horizon's
  // cart page and product forms announce changes as
  // shopify:cart:lines-update, and the Dlook product cards' bag buttons as
  // cart:refresh. Listen for both so the bag count follows the cart.
  // The event fires as the change starts; event.promise settles once Shopify
  // has saved it. Reading the cart before then gave the previous count.
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(loadCart, function () { /* failed change: count unchanged */ });
    } else {
      loadCart();
    }
  });
  document.addEventListener('cart:refresh', loadCart);
  // Coming back to a page from the browser history restores it as it was,
  // including an old count, so refresh then too.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) loadCart();
  });
  document.addEventListener('dlook:cart:open', function () { open('cart'); });
})();
